export enum ActionRolesEnum {
    cancel = 'cancel',
    add = 'add',
    confirm = 'confirm',
    delete = 'delete',
    continue = 'continue',
    error = 'error',
    switch = 'switch',
}
